import React from 'react';
import type { CrewReportHint } from './CrewReportSearchHeader';

/** Shared Help popover copy for Crew Changes Cost (list + detail). */
export const TRAVEL_TICKETS_HELP: CrewReportHint = {
  title: 'Crew Changes Cost',
  body: (
    <div className="space-y-2.5">
      <p>
        There are two kinds of records: <strong>Visit</strong> (anyone — superintendent, auditor,
        guest) and <strong>Changing crew</strong> (sign-off with optional sign-on relief).
      </p>
      <p>
        A <strong>crew-change cost record is one travel pack</strong> for a single replacement /
        handover — not two separate packs — even when S/On and S/Off fly on different days.
      </p>
      <ul className="list-disc space-y-1.5 pl-4">
        <li>
          <strong>S/On (relief)</strong> usually arrives early for familiarization while the outgoing
          crew is still onboard.
        </li>
        <li>
          <strong>S/Off (outgoing)</strong> leaves later, after handover — often not the same flight
          day as the relief.
        </li>
        <li>
          Different days are normal. Legs stay on the same pack, tagged by side (S/On vs S/Off).
        </li>
        <li>
          Status, vessel, change port, and the link to the replacement planner stay on that one pack.
        </li>
      </ul>
      <p>
        Open a record to see each person&apos;s journey separately. Use Edit to change travelers or
        flight legs.
      </p>
    </div>
  ),
};
